export enum ExpenseSection {
    Summary
    , Detail
    , Receipt
}
